import I18n from '../i18n';

export default {
    get: (err: any) => {
        console.error(err);

        let defaultError = err.code ? [err.code] : ['DEFAULT_ERROR'];

        if (err.response && err.response.data && err.response.data.err && err.response.data.err.errors && err.response.data.err.errors.length) {
            defaultError = err.response.data.err.errors;
        }

        const translateError = I18n.lApi(defaultError);
        return translateError;
    }
}